<template>
    <b-card no-body>
        <b-card-header>
            <span class="h5">
                CONTRATO -
                <strong>
                    {{ contrato.vcCodigoEstruturado }} -
                    {{ contrato.fornecedor ? contrato.fornecedor.nome : '' }}
                </strong>
                <b-badge variant="warning" class="ml-2">{{ operacao }}</b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row v-if="contratoElaboracao() || aditivarContrato()">
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label class="required" for="numeroContrato">
                            Número do contrato
                        </label>
                        <b-input-group>
                            <b-form-input
                                v-if="aditivarContrato()"
                                type="text"
                                id="numeroContrato"
                                v-model="codigoEstruturado"
                                :disabled="true"
                            ></b-form-input>
                            <b-form-input
                                v-else
                                type="text"
                                id="numeroContrato"
                                placeholder="Digite o número do contrato"
                                v-model="codigoEstruturado"
                                :state="
                                    $v.codigoEstruturado.$error ? false : null
                                "
                                @input.native="$v.codigoEstruturado.$touch()"
                                v-mask="'###/####/XXXX'"
                                max="13"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >O número do contrato é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label for="numeroProcessoCliente"
                            >Processo cliente</label
                        >
                        <b-input-group>
                            <b-form-input
                                type="text"
                                id="numeroProcessoCliente"
                                placeholder="Digite o número do processo do cliente"
                                v-model="processoCliente"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label class="required">Gestor</label>
                        <model-list-select
                            :list="funcionarios"
                            option-text="codNomeFuncionario"
                            option-value="codFuncionario"
                            v-model="codSolicitante"
                        ></model-list-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label class="required">Centro de Custo</label>
                        <model-list-select
                            :list="unidades"
                            option-text="nomeCodCCusto"
                            option-value="codCCusto"
                            v-model="codUnidade"
                        ></model-list-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label class="required">
                            Tipo do Contrato
                        </label>
                        <b-form-select
                            :options="tipoContratoOptions"
                            v-model="tipoContratoId"
                            text-field="descricao"
                            value-field="tipoContratoId"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col class="v-center" sm="12" md="2">
                    <b-form-group>
                        <b-form-checkbox
                            v-model="prorrogavel"
                            :value="true"
                            :unchecked-value="false"
                        >
                            Prorrogável
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2" v-if="false">
                    <b-form-group>
                        <label>Tipo do Movimento</label>
                        <b-form-select
                            :options="tipoMovimentoOptions"
                            v-model="tipoMovimento"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label class="required">Fiscal</label>
                        <model-list-select
                            :list="funcionarios"
                            option-text="codNomeFuncionario"
                            option-value="codFuncionario"
                            v-model="codFiscal"
                        ></model-list-select>
                    </b-form-group>
                </b-col>

                <b-col sm="12" md="9">
                    <b-row>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label>Data de publicação do DOE</label>
                                <date-picker
                                    v-model="dataDePublicacaoDoDOE"
                                    :config="$datePickerOptions"
                                    v-mask="'##/##/####'"
                                ></date-picker>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group>
                                <label>Anexo DOE</label>
                                <b-row>
                                    <b-col>
                                        <div class="float-left" style="width: 90%">
                                            <b-form-file
                                                v-model="arquivoAnexoDoDOE"
                                                :placeholder="placeholderDOE"
                                                ref="documentoInput"
                                                browse-text="Selecionar"
                                            ></b-form-file>
                                        </div>
                                        <div
                                            v-if="placeholderDOE != 'Selecione o Anexo...'"
                                            class="text-primary ms-2 ml-4 mt-2 float-left">
                                            <i
                                                class="fa fa-download fa-lg icon-button"
                                                title="Download Anexo DOE"
                                                @click.stop="downloadAnexoDoe()"
                                            ></i>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label>Data de publicação do DOU</label>
                                <date-picker
                                    v-model="dataDePublicacaoDoDOU"
                                    :config="$datePickerOptions"
                                    v-mask="'##/##/####'"
                                ></date-picker>
                            </b-form-group>
                        </b-col>

                        <b-col>
                            <b-form-group>
                                <label>Anexo DOU</label>
                                <b-row>
                                    <b-col>
                                        <div class="float-left" style="width: 90%">
                                            <b-form-file
                                                v-model="arquivoAnexoDoDOU"
                                                :placeholder="placeholderDOU"
                                                ref="documentoInput"
                                                browse-text="Selecionar"
                                            ></b-form-file>
                                        </div>
                                        <div
                                            v-if="placeholderDOU != 'Selecione o Anexo...'"
                                            class="text-primary ms-2 ml-4 mt-2 float-left">
                                            <i
                                                class="fa fa-download fa-lg icon-button"
                                                title="Download Anexo DOU"
                                                @click.stop="downloadAnexoDou()"
                                            ></i>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.objetoContrato.$error ? false : null"
                        invalid-feedback="O campo Objeto do Contrato é obrigatório"
                    >
                        <label class="required">Objeto do Contrato</label>
                        <b-form-textarea
                            v-model="objetoContrato"
                            :rows="4"
                            maxlength="1000"
                            @input.native="$v.objetoContrato.$touch()"
                        ></b-form-textarea>
                        <small class="text-muted">
                                {{ objetoContratoLength }}/1000 caracteres
                            </small>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="4" md="3">
                    <b-form-group
                        :state="$v.origemVigencia.$error ? false : null"
                        invalid-feedback="O campo Origem da Vigência é obrigatório"
                    >
                        <label class="required" >
                            Origem da Vigência
                        </label>
                        <b-form-select
                            :options="origensVigencia"
                            v-model="origemVigencia"
                            text-field="descricao"
                            value-field="id"
                            @blur="$v.origemVigencia.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="4" md="3">
                    <b-form-group
                        :state="$v.diaFaturamento.$error ? false : null"
                        invalid-feedback="O dia de faturamento é obrigatório"
                    >
                        <label class="required"> Dia de Faturamento </label>
                        <b-form-input v-if="podeAlterarDiaFaturamento"
                            v-model="diaFaturamento"
                            v-mask="'##'"
                            placeholder="Digite o dia de faturamento"
                            @input.native="$v.diaFaturamento.$touch()"
                        >
                        </b-form-input>
                        <p v-else>
                            {{ diaFaturamento }}
                            <input type="hidden" v-model="diaFaturamento">
                        </p>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.vigenciaInicio.$error ? false : null"
                        invalid-feedback="O campo Vigência Início é obrigatório"
                    >
                        <label :class="{ required: !origemVigenciaTipo3 }" >
                            Vigência Início
                        </label>
                        <date-picker
                            v-model="vigenciaInicio"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.vigenciaInicio.$touch()"
                            :disabled="desabilitaOrigemDataGestor || desabilitaVigenciaPorTipoAditivo"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.vigenciaFim.$error ? false : null"
                        invalid-feedback="O campo Vigência Fim é obrigatório"
                    >
                        <label :class="{ required: !origemVigenciaTipo3 }" >
                            Vigência Fim
                        </label>
                        <date-picker
                            v-model="vigenciaFim"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.vigenciaFim.$touch()"
                            :disabled="desabilitaOrigemDataGestor || desabilitaVigenciaPorTipoAditivo"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.prazoInicio.$error ? false : null"
                        :invalid-feedback="mensagemValidacaoPrazoInicio"
                    >
                        <label :class="{ required: !origemVigenciaTipo3 }" >Prazo Execução Início</label>
                        <date-picker
                            v-model="prazoInicio"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            :disabled="desabilitaVigenciaPorTipoAditivo"
                            @input="$v.prazoInicio.$touch()"
                            @input.native="$v.prazoInicio.$touch()"
                            @blur.native="$v.prazoInicio.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.prazoFim.$error ? false : null"
                        :invalid-feedback="mensagemValidacaoPrazoFim"
                    >
                        <label :class="{ required: !origemVigenciaTipo3 }" >Prazo Execução Fim</label>
                        <date-picker
                            v-model="prazoFim"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            :disabled="desabilitaVigenciaPorTipoAditivo"
                            @input="$v.prazoFim.$touch()"
                            @input.native="$v.prazoFim.$touch()"
                            @blur.native="$v.prazoFim.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="apostilamento() || atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label class="required"
                            >Justificativa {{ labelJustificativa }}</label
                        >
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="2"
                            @input.native="
                                $v.justificativaApostilamento.$touch()
                            "
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa {{ textoInfoJustificativa }} é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Referência</label>
                        <b-form-textarea
                            v-model="vcReferencia"
                            :rows="2"
                            maxlength="500"
                        ></b-form-textarea>
                        <small class="d-block text-right text-muted">
                            {{ (vcReferencia || '').length }}/500
                        </small>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card-body>
        <b-card-footer>
            <b-button variant="danger" @click.stop="voltar()" class="mr-1">
                <span> <i class="fa fa-history"></i> Cancelar </span>
            </b-button>
            <b-button
                variant="primary"
                :disabled="desabilitarBtnSalvar"
                @click.stop="confirmaSalvar()"
            >
                <i class="fa fa-save"></i> Salvar
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ContratosServicos from './ContratosServicos'
import { situacaoContrato } from './SituacaoContrato'
import { alteraPrazo } from './aditivarContrato/TipoAditivoIds'
import { ModelListSelect } from 'vue-search-select'
import PreContratoServicos from './preContrato/PreContratoServicos'

export default {
    components: {
        ModelListSelect
    },

    data() {
        return {
            contrato: {},
            erros: [],
            codigoEstruturado: '',
            processoCliente: '',
            operacao: '',
            codSolicitante: null,
            funcionarios: [],
            fornecedoresGestor: [],
            codUnidade: null,
            unidades: [],
            vigenciaInicio: null,
            vigenciaFim: null,
            prazoInicio: null,
            prazoFim: null,
            dtEnvioFornecedor: null,
            dtRetornoFornecedor: null,
            dtEnvioDiretoria: null,
            dtRetornoDiretoria: null,
            objetoContrato: '',
            vcReferencia: '',
            garantiaOptions: [
                { flGarantia: 0, descrGarantia: 'NÃO' },
                { flGarantia: 1, descrGarantia: 'SIM' }
            ],
            tipoMovimentoOptions: ['1.1.80', '1.1.15', '1.1.79'],
            tipoContratoOptions: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            tipoContratoId: 0,
            tipoMovimento: '1.1.80',
            justificativaApostilamento: '',
            apostilar: null,
            labelJustificativa: '',
            textoInfoJustificativa: '',
            prorrogavel: false,
            codFiscal: null,
            origensVigencia: [],
            origemVigencia: null,
            usuarioEmail: null,
            diaFaturamento: 1,
            dataDePublicacaoDoDOE: '',
            dataDePublicacaoDoDOU: '',
            arquivoAnexoDoDOE: '',
            arquivoAnexoDoDOU: '',
            placeholderDOE: 'Selecione o Anexo...',
            placeholderDOU: 'Selecione o Anexo...',
            nomeAnexoDoDOE: '',
            nomeAnexoDoDOU: '',
        }
    },

    methods: {
        voltar() {
            this.erros = []
            if (
                this.vigenciaInicio !=
                    this.$moment(this.contrato.dtInicioVigencia).format(
                        'DD/MM/YYYY'
                    ) ||
                this.vigenciaFim !=
                    this.$moment(this.contrato.dtFimVigencia).format(
                        'DD/MM/YYYY'
                    ) ||
                this.objetoContrato != this.contrato.vcObjetoContrato ||
                (this.vcReferencia || '') != (this.contrato.vcReferencia || '')
            ) {
                this.$store.dispatch('setRecarregar', true)
            }
            this.$router.push({
                name: 'Contratos_Detalhar',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        confirmaSalvar() {
            let acao = ''
            let titulo = ''
            if (
                (this.contratoElaboracao() || this.atualizacaoContrato()) &&
                !this.$route.params.apostilar
            ) {
                acao = 'a atualização'
                titulo = 'Atualização'
            } else if (this.apostilamento()) {
                acao = 'o apostilamento'
                titulo = 'Apostilamento'
            }

            this.$swal({
                title: titulo,
                html: `Confirma ${acao} para o contrato <b>${this.contrato.vcCodigoEstruturado} - ${this.contrato.fornecedor.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let apostilamentoAtualizacaoDto = {
                idContrato: this.contrato.idContrato,
                codSolicitante: this.codSolicitante,
                codUnidade: this.codUnidade,
                nomeUnidade: this.unidades.find(
                    (x) => x.codCCusto === this.codUnidade
                ).nomeCCusto,
                dtInicioVigencia:
                    this.vigenciaInicio != null
                        ? this.$moment(this.vigenciaInicio, 'DD/MM/YYYY').toISOString()
                        : null,
                dtFimVigencia:
                    this.vigenciaFim != null
                        ? this.$moment(this.vigenciaFim, 'DD/MM/YYYY').toISOString()
                        : null,
                dtInicioPrazoExecucao:
                    this.prazoInicio != null
                        ? this.$moment(this.prazoInicio, 'DD/MM/YYYY').toISOString()
                        : null,
                dtFimPrazoExecucao:
                    this.prazoFim != null
                        ? this.$moment(this.prazoFim, 'DD/MM/YYYY').toISOString()
                        : null,
                vcObjetoContrato: this.objetoContrato,
                vcReferencia: this.vcReferencia,
                processoCliente: this.processoCliente,
                tipoContratoId: this.tipoContratoId == 0 ? null : this.tipoContratoId,
                tipoMovimento: this.tipoMovimento,
                isApostilamento: this.apostilar,
                prorrogavel: this.prorrogavel,
                fiscal: this.obterFiscal(),
                origemVigencia: this.origemVigencia,
                diaFaturamento: this.diaFaturamento ? this.diaFaturamento : 0,
                dataDePublicacaoDoDOE:
                    this.dataDePublicacaoDoDOE
                    ? this.$moment(this.dataDePublicacaoDoDOE, 'DD/MM/YYYY').toISOString()
                    : null,
                arquivoAnexoDoDOE: this.arquivoAnexoDoDOE,
                dataDePublicacaoDoDOU:
                    this.dataDePublicacaoDoDOU
                    ? this.$moment(this.dataDePublicacaoDoDOU, 'DD/MM/YYYY').toISOString()
                    : null,
                arquivoAnexoDoDOU: this.arquivoAnexoDoDOU
            }

            if (this.contratoElaboracao() || this.aditivarContrato()) {
                apostilamentoAtualizacaoDto.justificativaApostilamento = null
                apostilamentoAtualizacaoDto.vcCodigoEstruturado =
                    this.codigoEstruturado
                apostilamentoAtualizacaoDto.isAditivo = this.aditivarContrato()

                ContratosServicos.atualizarContrato(apostilamentoAtualizacaoDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.mensagemSucesso(response.data)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else if (this.apostilamento()) {
                apostilamentoAtualizacaoDto.justificativaApostilamento =
                    this.justificativaApostilamento

                ContratosServicos.apostilarContrato(apostilamentoAtualizacaoDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.mensagemSucesso(response.data)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        obterFiscal() {
            if (this.codFiscal == null) {
                return null
            }

            return this.funcionarios.find(x => x.codFuncionario == this.codFiscal)
        },

        obterContrato() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterPorIdApostilar(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.preencheFormulario(response.data)
                        this.verificaOperacao()
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        preencheFormulario(data) {
            this.contrato = data
            this.codigoEstruturado = data.vcCodigoEstruturado
            this.processoCliente = data.processoCliente
            this.unidades = data.unidades
            this.funcionarios = data.funcionarios
            this.fornecedoresGestor = data.fornecedoresGestor
            this.origensVigencia = data.origensVigencia
            this.codSolicitante = data.codSolicitante
            this.codUnidade = data.codUnidade
            this.prorrogavel = data.prorrogavel
            this.codFiscal = data.codFiscal
            this.origemVigencia = data.origemVigencia
            this.usuarioEmail = data.usuarioEmail

            this.vigenciaInicio = data.dtInicioVigencia != null
                ? this.$moment(data.dtInicioVigencia).format('DD/MM/YYYY')
                : null
            this.vigenciaFim = data.dtFimVigencia != null
                ? this.$moment(data.dtFimVigencia).format('DD/MM/YYYY')
                : null
            this.prazoInicio = data.dtInicioPrazoExecucao != null
                ? this.$moment(data.dtInicioPrazoExecucao).format('DD/MM/YYYY')
                : null
            this.prazoFim = data.dtFimPrazoExecucao != null
                ? this.$moment(data.dtFimPrazoExecucao).format('DD/MM/YYYY')
                : null
            this.objetoContrato = data.vcObjetoContrato
            this.vcReferencia = data.vcReferencia || ''
            this.tipoContratoId =
                data.idTipoContrato == null ? 0 : data.idTipoContrato
            this.tipoMovimento = data.tipoMovimento ? data.tipoMovimento : null
            this.definirTipoContratoOptions(data)
            this.diaFaturamento = data.diaFaturamento
            this.dataDePublicacaoDoDOE = data.dataDePublicacaoDoDOE != null
                ? this.$moment(data.dataDePublicacaoDoDOE).format('DD/MM/YYYY')
                : null
            this.arquivoAnexoDoDOE = data.nomeAnexoDoDOE
            this.dataDePublicacaoDoDOU = data.dataDePublicacaoDoDOU != null
                ? this.$moment(data.dataDePublicacaoDoDOU).format('DD/MM/YYYY')
                : null
            this.arquivoAnexoDoDOU = data.nomeAnexoDoDOU

            this.placeholderDOE = data.nomeAnexoDoDOE
            this.placeholderDOU = data.nomeAnexoDoDOU

            this.$nextTick(() => {
                if (this.$v) {
                    this.$v.$reset()
                }
            })

        },

        definirTipoContratoOptions(contrato) {
            if (
                contrato.temFaseDemanda &&
                !contrato.temFaseEntrega &&
                !contrato.temFaseParcelaFixa
            ) {
                this.tipoContratoOptions.push({
                    tipoContratoId: 1,
                    descricao: 'POR DEMANDA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            } else if (
                !contrato.temFaseDemanda &&
                contrato.temFaseEntrega &&
                !contrato.temFaseParcelaFixa
            ) {
                this.tipoContratoOptions.push({
                    tipoContratoId: 3,
                    descricao: 'POR ENTREGA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            } else if (
                !contrato.temFaseDemanda &&
                !contrato.temFaseEntrega &&
                contrato.temFaseParcelaFixa
            ) {
                this.tipoContratoOptions.push({
                    tipoContratoId: 2,
                    descricao: 'PARCELA FIXA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            } else if (
                (contrato.temFaseDemanda && contrato.temFaseEntrega) ||
                (contrato.temFaseDemanda && contrato.temFaseParcelaFixa) ||
                (contrato.temFaseEntrega && contrato.temFaseParcelaFixa) ||
                (contrato.temFaseDemanda &&
                    contrato.temFaseEntrega &&
                    contrato.temFaseParcelaFixa)
            ) {
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            } else {
                this.tipoContratoOptions.push({
                    tipoContratoId: 1,
                    descricao: 'POR DEMANDA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 2,
                    descricao: 'PARCELA FIXA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 3,
                    descricao: 'POR ENTREGA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            }
        },

        mensagemSucesso() {
            let acao = ''
            if (
                (this.contratoElaboracao() || this.atualizacaoContrato()) &&
                !this.apostilar
            ) {
                acao = 'atualizado'
            } else if (this.apostilamento()) {
                acao = 'salvo'
            }

            this.$toast.success(
                `Registro ${acao} com sucesso!`,
                'OK',
                this.$toastConfig.success
            )
            this.voltar()
        },

        registrosInalterados() {
            return (
                this.codigoEstruturado == this.contrato.vcCodigoEstruturado &&
                this.processoCliente == this.contrato.processoCliente &&
                this.codSolicitante == this.contrato.codSolicitante &&
                this.codUnidade == this.contrato.codUnidade &&
                this.objetoContrato == this.contrato.vcObjetoContrato &&
                (this.vcReferencia || '') == (this.contrato.vcReferencia || '') &&
                this.vigenciaInicio ==
                    this.$moment(this.contrato.dtInicioVigencia).format(
                        'DD/MM/YYYY'
                    ) &&
                this.vigenciaFim ==
                    this.$moment(this.contrato.dtFimVigencia).format(
                        'DD/MM/YYYY'
                    ) &&
                this.prazoInicio ==
                    this.$moment(this.contrato.dtInicioPrazoExecucao).format(
                        'DD/MM/YYYY'
                    ) &&
                this.prazoFim ==
                    this.$moment(this.contrato.dtFimPrazoExecucao).format(
                        'DD/MM/YYYY'
                    ) &&
                this.tipoContratoId == this.contrato.idTipoContrato &&
                this.tipoMovimento == this.contrato.tipoMovimento &&
                this.prorrogavel == this.contrato.prorrogavel &&
                this.codFiscal == this.contrato.codFiscal &&
                this.origemVigencia == this.contrato.origemVigencia &&
                this.diaFaturamento == this.contrato.diaFaturamento
            )
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        apostilamento() {
            return this.situacoesVigenteDistribuido()
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivarContrato() {
            return (
                this.$temAcessoView('CONT-ADITIV-00') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido()
            )
        },

        verificaOperacao() {
            if (this.apostilamento() && this.apostilar) {
                this.operacao = 'APOSTILAR'
                this.labelJustificativa = 'do Apostilamento'
                this.textoInfoJustificativa = 'apostilamento'
            } else if (
                this.contratoElaboracao() ||
                this.atualizacaoContrato()
            ) {
                this.operacao = 'ATUALIZAR'
            }
        },

        verificaCampoApostilamento() {
            if (this.apostilamento() && this.apostilar) {
                if (this.justificativaApostilamento != '') {
                    return true
                }
            } else if (this.contratoElaboracao() || this.aditivarContrato()) {
                return true
            } else if (this.atualizacaoContrato() && !this.apostilar) {
                if (this.justificativaApostilamento != '') {
                    return true
                }
            }
            return false
        },

        verificaCampoNumeroContrato() {
            if (this.apostilamento()) {
                return true
            } else if (
                (this.contratoElaboracao() || this.aditivarContrato()) &&
                this.codigoEstruturado.length > 0
            ) {
                return true
            }
            return false
        }
    },

    created() {
        this.apostilar =
            this.$route.params.apostilar != undefined
                ? this.$route.params.apostilar
                : false
        this.obterContrato()
    },

    computed: {
        podeAlterarDiaFaturamento(){
            const statusContratosPermitidos = [
                situacaoContrato.PRE_CONTRATO_CONCLUIDO,
                situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO,
                situacaoContrato.CONTRATO_DISTRIBUIDO];

            const statusAditivoPermitidos = [
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO,
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO,
                    situacaoContrato.ADITIVO_DISTRIBUIDO];

            return (statusContratosPermitidos.includes(this.contrato.idSituacaoContrato) || statusAditivoPermitidos.includes(this.contrato.idSituacaoContrato));
        },

        gestorEscolhido() {
            if (this.codSolicitante == null) {
                return null
            }

            return this.funcionarios.find(x => x.codFuncionario == this.codSolicitante)
        },

        desabilitaOrigemDataGestor() {
            if (this.gestorEscolhido == null || this.gestorEscolhido.email == null) {
                return false
            }

            if (this.gestorEscolhido.email != this.usuarioEmail && this.origemVigencia == 3) {
                return true
            }

            return false
        },

        aditivoAlteraPrazo() {
            return this.contrato.aditivoContrato != null
                ? alteraPrazo(
                      this.contrato.aditivoContrato.aditivoTiposAditivo.map(
                          x => x.idTipoAditivo
                      )
                  )
                : false
        },

        desabilitaVigenciaPorTipoAditivo() {
            return this.aditivarContrato() && !this.aditivoAlteraPrazo
        },

        objetoContratoLength() {
            return this.objetoContrato ? this.objetoContrato.length : 0
        },

        desabilitarBtnSalvar() {
            if (this.contratoElaboracao() || this.atualizacaoContrato()) {
                return this.$v.$invalid
            } else {
                if (this.$v.$invalid) return true
                else if (this.justificativa == '') return true

                return false
            }
        },

        origemVigenciaTipo3() {
            return this.origemVigencia == 3
        },

        vigenciaInicioOk() {
            if (this.origemVigenciaTipo3 && !this.vigenciaInicio) return true
            return this.$moment(this.vigenciaInicio, 'DD/MM/YYYY', true).isValid()
        },

        vigenciaFimOk() {
            if (this.origemVigenciaTipo3 && !this.vigenciaFim) return true
            return this.$moment(this.vigenciaFim, 'DD/MM/YYYY', true).isValid()
        },

        origemVigenciaOk() {
            return (
                this.origemVigencia !== null &&
                this.origemVigencia !== undefined &&
                this.origemVigencia !== ''
            )
        },

        prazoInicioOk() {
            if (this.origemVigenciaTipo3 && !this.prazoInicio) return true
            return this.$moment(this.prazoInicio, 'DD/MM/YYYY', true).isValid()
        },

        prazoFimOk() {
            if (this.origemVigenciaTipo3 && !this.prazoFim) return true
            return this.$moment(this.prazoFim, 'DD/MM/YYYY', true).isValid()
        },

        prazoInicioDentroVigenciaOk() {
            if (!this.prazoInicio || !this.vigenciaInicio || !this.vigenciaFim) {
                return true
            }

            const prazoInicio = this.$moment(this.prazoInicio, 'DD/MM/YYYY', true)
            const vigenciaInicio = this.$moment(this.vigenciaInicio, 'DD/MM/YYYY', true)
            const vigenciaFim = this.$moment(this.vigenciaFim, 'DD/MM/YYYY', true)

            if (!prazoInicio.isValid() || !vigenciaInicio.isValid() || !vigenciaFim.isValid()) {
                return true
            }

            return (
                prazoInicio.isSameOrAfter(vigenciaInicio, 'day') &&
                prazoInicio.isSameOrBefore(vigenciaFim, 'day')
            )
        },

        prazoFimDentroVigenciaOk() {
            if (!this.prazoFim || !this.vigenciaInicio || !this.vigenciaFim) {
                return true
            }

            const prazoFim = this.$moment(this.prazoFim, 'DD/MM/YYYY', true)
            const vigenciaInicio = this.$moment(this.vigenciaInicio, 'DD/MM/YYYY', true)
            const vigenciaFim = this.$moment(this.vigenciaFim, 'DD/MM/YYYY', true)

            if (!prazoFim.isValid() || !vigenciaInicio.isValid() || !vigenciaFim.isValid()) {
                return true
            }

            return (
                prazoFim.isSameOrAfter(vigenciaInicio, 'day') &&
                prazoFim.isSameOrBefore(vigenciaFim, 'day')
            )
        },

        mensagemValidacaoPrazoInicio() {
            if (
                this.$v &&
                this.$v.prazoInicio &&
                !this.$v.prazoInicio.obrigatorio
            ) {
                return 'O campo Prazo Execução Início é obrigatório'
            }

            return 'A data de execução deve estar dentro da vigência do contrato'
        },

        mensagemValidacaoPrazoFim() {
            if (
                this.$v &&
                this.$v.prazoFim &&
                !this.$v.prazoFim.obrigatorio
            ) {
                return 'O campo Prazo Execução Fim é obrigatório'
            }

            return 'A data de execução deve estar dentro da vigência do contrato'
        },

        precisaTipoContrato() {
            return (
                this.contrato.idSituacaoContrato !=
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO
            )
        },

        tipoContratoOk() {
            if (!this.precisaTipoContrato) {
                return true
            }

            return this.tipoContratoId != 0
        },

        diFaturamentoOK() {
            return this.diaFaturamento || this.diaFaturamento != 0
        },

        downloadAnexoDoe() {
            this.$store.dispatch('addRequest')
            PreContratoServicos.downloadAnexoDoe(this.contrato).then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao realizar download do arquivo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, this.contrato.nomeAnexoDoDOE)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        downloadAnexoDou() {
            this.$store.dispatch('addRequest')
            PreContratoServicos.downloadAnexoDou(this.contrato).then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao realizar download do arquivo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, this.contrato.nomeAnexoDoDOU)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },

    validations: {
        idContrato: {
            contratoAlterado() {
                return !this.registrosInalterados()
            }
        },
        objetoContrato: {
            required
        },
        codSolicitante: {
            required
        },
        codUnidade: {
            required
        },
        tipoContratoId: {
            obrigatorio() {
                return this.tipoContratoOk
            }
        },
        vigenciaInicio: {
            obrigatorio() {
                return this.vigenciaInicioOk
            }
        },
        vigenciaFim: {
            obrigatorio() {
                return this.vigenciaFimOk
            }
        },
        origemVigencia: {
            obrigatorio() {
                return this.origemVigenciaOk
            }
        },
        prazoInicio: {
            obrigatorio() {
                return this.prazoInicioOk
            },
            dentroDaVigencia() {
                return this.prazoInicioDentroVigenciaOk
            }
        },
        prazoFim: {
            obrigatorio() {
                return this.prazoFimOk
            },
            dentroDaVigencia() {
                return this.prazoFimDentroVigenciaOk
            }
        },
        codFiscal: {
            required
        },
        justificativaApostilamento: {
            verificaCampoApostilamento() {
                return this.verificaCampoApostilamento()
            }
        },
        codigoEstruturado: {
            verificaSituacao() {
                return this.verificaCampoNumeroContrato()
            }
        },
        diaFaturamento: {
            obrigatorio() {
                return this.diFaturamentoOK
            }
        }
    }
}
</script>
<style>
    .v-center {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: -1rem;
    }
</style>
